<template>
  <div class="profile-container">
    <div class="profile-header"></div>
    <div id="profile" class="home-container-content">
      <div class="home-container-content-item">
        <ContainerCom :contentId="'2'">
          <div class="home-container-content-item-right">
            <div>
              <TextCom :contentId="'3'" />
            </div>
            <div>
              <TextCom :contentId="'4'" />
            </div>

            <TextCom :contentId="'5'" />
            <ButtonCom class="button-group" :contentId="'6'" />
          </div>
        </ContainerCom>
      </div>
      <div class="home-container-content-item">
        <ContainerCom :contentId="'1'"> </ContainerCom>
      </div>
    </div>
    <div id="team" class="home-container-content">
      <div class="home-container-content-item">
        <ContainerCom :contentId="'8'"> </ContainerCom>
      </div>
      <div class="home-container-content-item">
        <ContainerCom :contentId="'9'">
          <div class="home-container-content-item-right">
            <div>
              <TextCom :contentId="'10'" />
            </div>
            <div>
              <TextCom :contentId="'11'" />
            </div>

            <TextCom :contentId="'12'" />
            <ButtonCom class="button-group" :contentId="'13'" />
          </div>
        </ContainerCom>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject, onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import Technology from "../components/Technology.vue";
const router = useRouter();
// 注入修改navbar文字颜色的方法
const changeNavbarTextColor = inject("changeNavbarTextColor");
const handleHashNavigation = () => {
  const hash = router.currentRoute.value.hash;
  // 延迟执行以确保DOM已经渲染完成
  setTimeout(() => {
    if (hash) {
      // 移除hash前缀(#)
      const targetId = hash.substring(1);
      // 查找目标元素
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        // 平滑滚动到目标元素
        targetElement.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      } else {
        console.log(`未找到ID为${targetId}的元素`);
      }
    }
  }, 100);
};
// 组件挂载时将navbar文字颜色改为黑色
onMounted(() => {
  if (changeNavbarTextColor) {
    changeNavbarTextColor("#000000", "#000000"); // 改为黑色
  }
  handleHashNavigation();
});

// 组件卸载时恢复navbar文字颜色为白色
onUnmounted(() => {
  if (changeNavbarTextColor) {
    changeNavbarTextColor("white", "white"); // 恢复白色
  }
});
</script>

<style scoped>
/* .profile-container {
    height: 100vh;
} */
.profile-header {
  height: 70px;
  background-color: #f1f6fa;
}
.home-container-content {
  display: grid;
  /* 使用minmax确保列有最小宽度，auto-fit会自动调整列数 */
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  /* 在大屏幕上设置两列布局 */
  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
  /* 确保所有网格项目高度一致 */
  grid-auto-rows: 1fr;
  align-items: stretch;
}
.home-container-content-item {
  /* 网格布局中不需要设置宽度，由grid-template-columns控制 */
  min-width: 300px;
  min-height: 500px;
  /* 确保填充整个网格单元格高度 */
  height: 100%;
  display: flex;
  flex-direction: column;
}

.button-group {
  margin-top: 20px;
  display: flex;
  gap: 15px;
}
.home-container-content-item-right {
  padding: 15% 20% 20% 10%;
  text-align: left;
}
@media (max-width: 768px) {
  .home-container-content-item-right {
    padding: 10%;
    text-align: left;
  }
}
.button-group {
  margin-top: 40px;
}
.home-product {
  /* background-color: #f1f6fa; */
  background-color: #fff;
  text-align: center;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  padding: 120px 120px;
  gap: 40px;
  justify-items: center;
}
h1 {
  color: #333;
  text-align: center;
  margin: 2rem auto 1rem;
  width: 100%;
}
.product-card-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
}

/* 中屏幕适配（769px - 1100px） */
@media (min-width: 769px) and (max-width: 1100px) {
  .home-product {
    grid-template-columns: 1fr;
    padding: 20px 60px;
  }
}

/* 小屏幕适配（小于等于768px） */
@media (max-width: 768px) {
  .home-product {
    grid-template-columns: 1fr;
    padding: 20px 20px;
  }
}
</style>
